// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__GN","cls2":"SimplePaperPodcast-cls2_WPF SimplePaperPodcast-cls1__GN"};